import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Heading, TextAccent, Link } from '../../../components';
import { Wrapper, Section, Block, ImageWrapper, Figcaption } from './GroupTwoFeatures.style';

/**
 * Work/Sesame: Features group two
 */
const GroupTwoFeatures = () => {
  const data = useStaticQuery(graphql`
    query {
      contentful: file(relativePath: { eq: "sesame-contentful.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Section>
        <Block gridArea="continuous-experimentation">
          <Heading element="h3" size="h4" weight={700}>
            Continuous experimentation
          </Heading>
          <TextAccent>
            Together with my peers, we continuously improved our technology stack and development processes by
            collaborating in <strong>specialized guilds</strong> dedicated to architecture, tooling, and{' '}
            <Link to="/blog/on-fixtures/">testing strategies</Link>, emphasizing performance optimization and scalable
            solutions.
          </TextAccent>
        </Block>
        <Block gridArea="ui-development">
          <Heading element="h3" size="h4" weight={700}>
            Design system, Chromatic/Storybook, and accessibility (a11y)
          </Heading>
          <TextAccent>
            We built a modular design system to ensure consistency across web and mobile apps, using Storybook and
            Chromatic for documentation and visual regression testing. In parallel, we achieved WCAG AA compliance,
            improving usability for a broader audience and meeting the strict requirements of our enterprise partners.
          </TextAccent>
        </Block>
        <Block gridArea="cost-savings">
          <div>
            <Heading element="h3" size="h4" weight={700}>
              How I helped save $50K in under two weeks!
            </Heading>
            <TextAccent withSpacing>
              Our consumer-facing marketing website relied on <strong>Contentful</strong> as a headless CMS. Over the
              years, we had accumulated a mix of structured and unstructured data; some planned, some not so much
              ¯\_(ツ)_/¯. As a result, we ended up on Contentful’s highest pricing tier, costing us over{' '}
              <strong>$50K per year</strong>.
            </TextAccent>
            <TextAccent>
              With just two weeks before the contract renewal, we took on the challenge of reworking our CMS setup. By
              streamlining the infrastructure, consolidating content models, and preparing a clean, scalable foundation,
              we successfully reduced costs and set the platform up for sustainable growth.
            </TextAccent>
          </div>
          <ImageWrapper>
            <Img
              fluid={data.contentful.childImageSharp.fluid}
              loading="eager"
              imgStyle={{ objectFit: 'contain' }}
              alt="Image of Slack message where I shared cost savings and performance optimizations"
            />
            <Figcaption>BONUS: significant performance optimizations ✨</Figcaption>
          </ImageWrapper>
        </Block>
      </Section>
    </Wrapper>
  );
};

export default GroupTwoFeatures;
